import { gql } from '@apollo/client';

export const LeadsQuery = gql`
  query Leads(
    $campaignId: ID
    $companyId: ID
    $endDate: DateTime!
    $startDate: DateTime!
    $before: String
    $take: Int
    $phone: String
    $status: [String!]
    $outreachTemplateId: Int
    $hasRepliesOnly: Boolean
    $includeCampaignName: Boolean = false
    $metadataFilter: MetadataFilterInput
  ) {
    externalLeads(
      campaignId: $campaignId
      companyId: $companyId
      endDate: $endDate
      startDate: $startDate
      before: $before
      take: $take
      phone: $phone
      status: $status
      outreachTemplateId: $outreachTemplateId
      hasRepliesOnly: $hasRepliesOnly
      metadataFilter: $metadataFilter
    ) {
      cursor
      totalCount
      statusCounts {
        status
        count
      }
      leads {
        campaignShortId
        campaignName @include(if: $includeCampaignName)
        createdAt
        firstName
        isDnc
        lastName
        phone
        region
        status
        undeliverableReason
        mostRecentMessage {
          body
          created
          direction
        }
      }
    }
  }
`;

export const ConversationQuery = gql`
  query Conversation(
    $campaignId: ID
    $companyId: ID
    $phone: ID!
    $includeCampaignName: Boolean = false
    $sinceIso: String
  ) {
    externalLead(campaignId: $campaignId, companyId: $companyId, phone: $phone) {
      campaignShortId
      campaignName @include(if: $includeCampaignName)
      createdAt
      firstName
      lastName
      phone
      isDnc
      timezone
      region
      status
      reposted
      repostedCount
      undeliverableReason
      lineType
      metadata
      phoneInfo {
        carrier
        lastCheck
        lineType
      }
      scheduledOutreach(since: $sinceIso) {
        kind
        when
        messagePreview
        flowStep
        flowType
        intent
      }
      conversation {
        inboundSms {
          body
          media {
            url
            contentType
          }
        }
        inboundCall {
          flowStep
          flowType
          isDnc
          isTransfer
          noResponse
        }
        outboundCall {
          answeredBy
          flowStep
          flowType
          isDnc
          isReschedule
          isTransfer
        }
        outboundSms {
          body
          status
          mediaUrl
        }
        recording {
          duration
          isTransfer
          recordingUrl
          direction
        }
        leadEvent {
          type
          eventId
          eventTime
          rescheduledTime
          cancelledTime
          events {
            integrationType
            actionType
            appointmentDetails {
              address
              previousAppointmentStartTime
              appointmentStartTime
              status
              title
              locationId
              appointmentStatus
              assignedUserId
              calendarId
              contactId
            }
            linkClickedDetails {
              ip
              clickedAt
              ipClickedCount
              userAgent
              linkKey
              shortUrl
              url
              utmMedium
              utmSource
              utmCampaign
            }
          }
        }
        time
      }
    }
  }
`;

export const SendSmsMutation = gql`
  mutation SendSms($input: SendSmsInput!) {
    sendSms(input: $input)
  }
`;

export const UpdateLeadStatusMutation = gql`
  mutation UpdateLeadStatus($input: UpdateLeadStatusInput!) {
    updateLeadStatus(input: $input)
  }
`;

export const UpdateLeadUndeliverableReasonMutation = gql`
  mutation UpdateLeadUndeliverableReason($input: UpdateLeadUndeliverableReasonInput!) {
    updateLeadUndeliverableReason(input: $input)
  }
`;

export const SyncLeadWithHighLevelMutation = gql`
  mutation SyncLeadWithHighLevel($input: SyncLeadWithHighLevelInput!) {
    syncLeadWithHighLevel(input: $input) {
      contactId
      changes {
        message
        eventId
        status
        time
      }
    }
  }
`;
